import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { BannerMessage } from '@shared/models';

import { environment } from '@env';

@Injectable({
    providedIn: 'root',
})
export class MessageBannerService {
    constructor(private http: HttpClient) {}

    fetchBannerMessages(): Observable<BannerMessage[]> {
        return this.http
            .get<any[]>(environment.endpoints.bannerMessagesList)
            .pipe(map<any[], BannerMessage[]>((messages) => messages.map((msg: any) => new BannerMessage().deserialize(msg))));
    }
}
